<template>
    <!-- 学员详情 -->
    <div class="stu-details">
        <div class="stu-details-top">
            <div class="stu-details-top-main">
                <div class="stu-details-top-main-logo">
                    <img class="img" :src="info.logourl  ? info.logourl : require('@/common/images/user.png')" alt="" srcset="">
                </div>
                <div>
                    <p class="mt-10">
                        <span class="color-title fs-large mr-10">{{info.name}}</span>
                        <span class="fs-mini color-text">{{info.nickname + `(${info.studentno})`}}</span>
                    </p>
                    <p class="color-text fs-medium mt-20">
                        <span class="mr-10">{{info.sexname}}</span>
                        <span class="mr-10">{{info.campusname}}</span>
                        <span>{{info.telno}}</span>
                    </p>
                    <p class="color-text fs-medium mt-30">
                        <span class="mr-20">完成学分数: {{info.totalscore}}</span>
                        <span>入班时间: {{info.recenttclasstime}}</span>
                    </p>
                </div>
            </div>
            <div class="stu-details-top-back">
                <el-button icon="el-icon-arrow-left" @click="goBack">返回上级</el-button>
            </div>
        </div>
        <div>
            <el-tabs v-model="activeName" @tab-click="handleClick">
                <el-tab-pane v-if="!classCode" label="班级信息" name="ClassInfo" :lazy="true">
                    <ClassInfo ref="ClassInfo" :code="studentCode"></ClassInfo>
                </el-tab-pane>
                <el-tab-pane label="课程信息" name="CourseInfo" :lazy="true">
                    <CourseInfo ref="CourseInfo" :classCode="classCode" :code="studentCode"></CourseInfo>
                </el-tab-pane>
                <el-tab-pane label="学情信息" name="StudyInfo" :lazy="true">
                    <el-tabs v-model="periodstatus" @tab-click="handleClick">
                        <el-tab-pane label="已上课" name="work" :lazy="true">
                            <StudyInfo :classCode="classCode" :code="studentCode" :periodstatus="30"></StudyInfo>
                        </el-tab-pane>
                        <el-tab-pane label="未上课" name="noWork" :lazy="true">
                            <StudyInfo :classCode="classCode" :code="studentCode" :periodstatus="10"></StudyInfo>
                        </el-tab-pane>
                    </el-tabs>
                </el-tab-pane>
                <el-tab-pane label="作业信息" name="WorkInfo" :lazy="true">
                    <WorkInfo :code="studentCode"></WorkInfo>
                </el-tab-pane>
                <el-tab-pane label="考试信息" name="ExamInfo" :lazy="true">
                    <ExamInfo :code="studentCode"></ExamInfo>
                </el-tab-pane>
            </el-tabs>
        </div>
    </div>
</template>
<script>
import { getStudentInfo } from '@/api/measApi/studentManage.js'
import ClassInfo from './components/classInfo.vue'
import CourseInfo from './components/courseInfo.vue'
import StudyInfo from './components/studyInfo.vue'
import WorkInfo from './components/workInfo.vue'
import ExamInfo from './components/examInfo.vue'

export default {
  data() {
    return {
      info: {
        name: '王刚',
        campusname: '创办大', // 所在校区
        nickname: '', // 昵称
        recenttclasstime: '2020-10-12', //
        sexname: '男', // 性别
        studentno: '111111', // 学员号
        telno: '17302813974', // 联系方式
        totalscore: '20' // 完成学分数
      },
      studentCode: '',
      activeName: 'ClassInfo',
      periodstatus: 'work'
    }
  },
  computed: {
    classCode() {
      return this.$route.query.classCode
    }
  },
  components: {
    ClassInfo,
    CourseInfo,
    StudyInfo,
    WorkInfo,
    ExamInfo
  },
  created() {
    this.studentCode = this.$route.query.code
    this.activeName = this.classCode ? 'CourseInfo' : 'ClassInfo'
    this.$nextTick(() => {
      this.getStudentInfo()
    })
  },
  methods: {
    //   获取顶部信息
    getStudentInfo() {
      getStudentInfo({ code: this.studentCode }).then(res => {
        if (res.code === '000') {
          this.info = res.data
          console.log(this.info)
        }
      })
    },
    // 返回上一级
    goBack() {
      this.$router.go(-1)
    },
    handleClick() {}
  }
}
</script>
<style lang="scss" scoped>
.stu-details {
  &-top {
    height: 157px;
    background: #f6f7fb;
    border-radius: 4px 4px 0px 0px;
    box-sizing: border-box;
    padding: 20px;
    display: flex;
    justify-content: space-between;
    &-main {
      display: flex;
      &-logo {
        width: 117px;
        height: 117px;
        background: #d9d9d9;
        border-radius: 50%;
        margin-right: 20px;
        .img {
          width: 117px;
          height: 117px;
          border-radius: 50%;
        }
      }
    }
  }
}
</style>

